import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { State } from '../vista-usuario/vista-usuario.state';

import { selectCurrentEmpresa } from '../empresas/entity-mis-empresas/entity-current-empresa.selectors';

@Injectable({providedIn: 'root'})
export class EmpresaGuardService implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<State>
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {    
    return this.store.pipe(
      select(selectCurrentEmpresa),
      map(empresa => {                     
        if (!!empresa) {
          return true;
        } else {
          this.router.navigate(['/empresas', 'mis-empresas'], { queryParams: { returnUrl: state.url }});
          return false;
        }
      })
    )    
  }
}
